import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Login from "../../Authentication/Login";
import WebsiteTabs from "../AllTabs/WebsiteTabs";

const initialFieldValues = {
  landingPageId: "00000000-0000-0000-0000-000000000000",
  companyId: "00000000-0000-0000-0000-000000000000",
  themeColor1: "#001F3F",
  themeColor2: "#007BFF",
  themeColor3: "#28A745",
  flightBackgroundFile: null,
  hotelBackgroundFile: null,
  holidayBackgroundFile: null,
  umrahBackgroundFile: null,
  sightSeeingBackgroundFile: null,
  flightBackgroundSrc: "",
  hotelBackgroundSrc: "",
  holidayBackgroundSrc: "",
  umrahBackgroundSrc: "",
  sightSeeingBackgroundSrc: "",
};

const LandingPage = () => {
  const { user, loading } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [values, setValues] = useState(initialFieldValues);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setValues({ ...values, [name]: files[0] });
    }
  };

  const getSettingsData = async () => {
    const companyId = user?.cid;
    if (!companyId) {
      console.error("Company ID is not defined in config.");
      return;
    }
    try {
      const res = await apiService.getById(
        `${config.GETLANDINGBYCOMPANY}`,
        `${companyId}`
      );
      console.log(res);
      if (res !== null) {
        setValues((prevValues) => ({ ...prevValues, ...res }));
      } else {
        setValues({ ...initialFieldValues, companyId: companyId });
      }
    } catch (error) {
      console.error("Failed to fetch landing page settings", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);

    const formData = new FormData();

    formData.append("landingPageId", values.landingPageId);
    formData.append("companyId", user?.cid);
    formData.append("themeColor1", values.themeColor1);
    formData.append("themeColor2", values.themeColor2);
    formData.append("themeColor3", values.themeColor3);
    formData.append("flightBackgroundFile", values.flightBackgroundFile);
    formData.append("hotelBackgroundFile", values.hotelBackgroundFile);
    formData.append("holidayBackgroundFile", values.holidayBackgroundFile);
    formData.append("umrahBackgroundFile", values.umrahBackgroundFile);
    formData.append(
      "sightSeeingBackgroundFile",
      values.sightSeeingBackgroundFile
    );

    try {
      await apiService.update(config.UPDATELANDINGPAGE, formData);
      await getSettingsData();
    } catch (error) {
      console.error("Failed to update settings", error);
    } finally {
      setBtnLoading(false);
    }
  };

  const getPreviewSrc = (file, existingSrc) => {
    if (file) {
      return URL.createObjectURL(file);
    }
    return existingSrc;
  };
  useEffect(() => {
    if (user && !loading) {
      getSettingsData();
    }
  }, [user, loading]);
  if (loading) return <p>Loading...</p>;
  if (!user) return <Login></Login>;
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="p-2">
                    <WebsiteTabs pageName="LANDINGPAGE" />
                  </div>
                  <div className="card-header">
                    <h4 className="card-title mb-0">
                      Landing Page Appearance Settings
                    </h4>
                  </div>
                  <div className="card-body">
                    <Form onSubmit={handleSubmit} autoComplete="off">
                      <h5 className="mb-3">Theme Colors</h5>
                      <Row>
                        <Col md={4} className="mb-3">
                          <Form.Label htmlFor="themeColor1">
                            Primary Color
                          </Form.Label>
                          <div className="d-flex align-items-center">
                            <Form.Control
                              type="color"
                              id="themeColor1"
                              name="themeColor1"
                              value={values.themeColor1 || "#000000"}
                              onChange={handleChange}
                              style={{ width: "50px" }}
                            />
                            <Form.Control
                              type="text"
                              className="ms-2"
                              value={values.themeColor1}
                              name="themeColor1"
                              onChange={handleChange}
                            />
                          </div>
                        </Col>
                        {/* Repeat for other colors */}
                        <Col md={4} className="mb-3">
                          <Form.Label htmlFor="themeColor2">
                            Accent Color
                          </Form.Label>
                          <div className="d-flex align-items-center">
                            <Form.Control
                              type="color"
                              id="themeColor2"
                              name="themeColor2"
                              value={values.themeColor2 || "#000000"}
                              onChange={handleChange}
                              style={{ width: "50px" }}
                            />
                            <Form.Control
                              type="text"
                              className="ms-2"
                              value={values.themeColor2}
                              name="themeColor2"
                              onChange={handleChange}
                            />
                          </div>
                        </Col>
                        <Col md={4} className="mb-3">
                          <Form.Label htmlFor="themeColor3">
                            Secondary Accent Color
                          </Form.Label>
                          <div className="d-flex align-items-center">
                            <Form.Control
                              type="color"
                              id="themeColor3"
                              name="themeColor3"
                              value={values.themeColor3 || "#000000"}
                              onChange={handleChange}
                              style={{ width: "50px" }}
                            />
                            <Form.Control
                              type="text"
                              className="ms-2"
                              value={values.themeColor3}
                              name="themeColor3"
                              onChange={handleChange}
                            />
                          </div>
                        </Col>
                      </Row>

                      <hr className="my-4" />

                      <h5 className="mb-3">Background Images</h5>

                      <Row className="mb-4">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Flight Background Image</Form.Label>
                            <Form.Control
                              type="file"
                              name="flightBackgroundFile"
                              onChange={handleFileChange}
                            />
                          </Form.Group>
                          {getPreviewSrc(
                            values.flightBackgroundFile,
                            values.flightBackgroundSrc
                          ) && (
                            <img
                              src={getPreviewSrc(
                                values.flightBackgroundFile,
                                values.flightBackgroundSrc
                              )}
                              alt="Flight Preview"
                              style={{
                                width: "150px",
                                borderRadius: "8px",
                                marginTop: "10px",
                              }}
                            />
                          )}
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Hotel Background Image</Form.Label>
                            <Form.Control
                              type="file"
                              name="hotelBackgroundFile"
                              onChange={handleFileChange}
                            />
                          </Form.Group>
                          {getPreviewSrc(
                            values.hotelBackgroundFile,
                            values.hotelBackgroundSrc
                          ) && (
                            <img
                              src={getPreviewSrc(
                                values.hotelBackgroundFile,
                                values.hotelBackgroundSrc
                              )}
                              alt="Hotel Preview"
                              style={{
                                width: "150px",
                                borderRadius: "8px",
                                marginTop: "10px",
                              }}
                            />
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-4">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Holiday Background Image</Form.Label>
                            <Form.Control
                              type="file"
                              name="holidayBackgroundFile"
                              onChange={handleFileChange}
                            />
                          </Form.Group>
                          {getPreviewSrc(
                            values.holidayBackgroundFile,
                            values.holidayBackgroundSrc
                          ) && (
                            <img
                              src={getPreviewSrc(
                                values.holidayBackgroundFile,
                                values.holidayBackgroundSrc
                              )}
                              alt="Holiday Preview"
                              style={{
                                width: "150px",
                                borderRadius: "8px",
                                marginTop: "10px",
                              }}
                            />
                          )}
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Umrah Background Image</Form.Label>
                            <Form.Control
                              type="file"
                              name="umrahBackgroundFile"
                              onChange={handleFileChange}
                            />
                          </Form.Group>
                          {getPreviewSrc(
                            values.umrahBackgroundFile,
                            values.umrahBackgroundSrc
                          ) && (
                            <img
                              src={getPreviewSrc(
                                values.umrahBackgroundFile,
                                values.umrahBackgroundSrc
                              )}
                              alt="Umrah Preview"
                              style={{
                                width: "150px",
                                borderRadius: "8px",
                                marginTop: "10px",
                              }}
                            />
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-4">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Sight Seeing Image</Form.Label>
                            <Form.Control
                              type="file"
                              name="sightSeeingBackgroundFile"
                              onChange={handleFileChange}
                            />
                          </Form.Group>
                          {getPreviewSrc(
                            values.sightSeeingBackgroundFile,
                            values.sightSeeingBackgroundSrc
                          ) && (
                            <img
                              src={getPreviewSrc(
                                values.sightSeeingBackgroundFile,
                                values.sightSeeingBackgroundSrc
                              )}
                              alt="Sightseeing Preview"
                              style={{
                                width: "150px",
                                borderRadius: "8px",
                                marginTop: "10px",
                              }}
                            />
                          )}
                        </Col>
                      </Row>

                      <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                        {btnLoading ? (
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled
                          >
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Updating...
                          </button>
                        ) : (
                          <button type="submit" className="btn btn-primary">
                            Update Settings
                          </button>
                        )}
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
